import { UploadChangeParam } from 'antd/lib/upload';
import Dragger from 'antd/lib/upload/Dragger';
import { UploadFile } from 'antd/lib/upload/interface';
import React, { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { COMMON_ERROR, GUTTOR_SPACE } from '../../../../shared/constants/commonConstants';
import { NEW_UPLOAD_STATUS, UPLOAD_STATUS } from '../../../../shared/constants/crmConstants';
import { GLOBAL_URL } from '../../../../shared/constants/dataServiceUrl';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import { RootState } from '../../../../store';
import { setUploadedFiles } from '../../../../store/actions/newAdmissionAction';
import { NewAdmissionState } from '../../../../store/models/newAdmissionModel';
import { fileBeforeUpload } from '../../../../utils/fileUploadUtils';
import { centeredNotification, sortByUid } from '../../../../utils/utility';
import { ReactComponent as UploadIcon } from '../../../../assets/images/svg/i_upload.svg';
import { Col, Row } from 'antd';
import Text from 'antd/lib/typography/Text';
import BuddhiMedUploadListItem from '../../../../shared/components/fileUpload/BuddhiMedUploadListItem';
import { getISTDateWithTimeSeconds } from '../../../../utils/dateTimeUtils';

const FileUploader = (): ReactElement => {
  const {
    uploadedFiles: fileList,
  } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { payerList: { payer} } = useSelector((state: RootState): any => state);
  const { id: payerId } = payer;
  const dispatch = useDispatch();
  const ALLOWED_FILE_EXTENSIONS = ApplicationDetail.instance.getAllowedFileExtension();

  const draggerActions = {
    fileList,
    name: 'file',
    data: {payerId},
    multiple: true,
    action: GLOBAL_URL.CRM_BASE_URL + 'Provider/File/Upload',
    withCredentials : true,
    beforeUpload: (event: any): any => fileBeforeUpload(event, payer),
    onChange: (fileInfo: UploadChangeParam<any>): void => {
      const { file: { response, status: fileStatus, existingRecord, uid: currFileUid }, event, fileList: fList } = fileInfo;
      if (fileStatus === UPLOAD_STATUS.done) {
        const { isSuccess, uploadedDetails, errors, errorMessage } = response;
        if (!existingRecord && isSuccess && uploadedDetails && uploadedDetails.length) {

          // if (isBuddhimedAllowed(fileInfo)) {
          //   buddhimedReqQueue.push(findFile);
          //   setBuddhimedReqQueue(buddhimedReqQueue);
          // }
        } else if (!isSuccess) {
          const brokenFileIndex = fList.findIndex((ele: any): boolean => ele?.uid === currFileUid);
          fList.splice(brokenFileIndex, 1);
          dispatch(setUploadedFiles([...sortByUid(fList)]));
          centeredNotification(errorMessage || errors?.join('\n') || COMMON_ERROR);
        }
      } else if (!fileStatus) {
        const perfectFileList = fList.filter((ele: any): boolean => ele?.uid !== currFileUid);
        dispatch(setUploadedFiles([...sortByUid(perfectFileList)]));
      }

      if (!event?.percent && fileStatus !== 'error' && response?.isSuccess) {

         // Find the specific file to update based on some unique identifier (e.g., uid)
           fList?.map((element: any): any => {
            // Apply the update only to the specific file that needs it
            if (element?.uid === currFileUid) { // condition to target the specific file
              element['claimStatus'] = element['claimStatus'] ? element['claimStatus'] : NEW_UPLOAD_STATUS;
              element['uploadedOn'] = getISTDateWithTimeSeconds(new Date()); // Apply timestamp only to the matching file
            }
            return element; // Return the updated element
          });
        dispatch(setUploadedFiles([...sortByUid(fList)]));
      }
    },
  };

  const draggerItemRender = (): null => null;

  const onRemove = (selectedUid: string): void => {
    const index = [...fileList].findIndex(({ uid }: any): boolean => uid === selectedUid);
    // const deletedClassification = classificationArray.filter(({ tempId }: any): boolean => tempId.includes(selectedUid));
    // if (deletedClassification && deletedClassification.length > 0) {
    //   deletedClassification.map((currElement: any): any => {
    //     currElement['isDeleted'] = true;
    //   });
    // }
    fileList.splice(index, 1);
    dispatch(setUploadedFiles([...fileList]));
    // dispatch(setClassificationArray([...classificationArray]));
    // billAmountArray.splice(newIndex, 1);
    // dispatch(setbillAmountArray([...(billAmountArray || [])]));
    // const { fileUploadRemark } = form?.getFieldsValue(['fileUploadRemark']) || {};
    // form?.resetFields();
    // form?.setFieldsValue({ fileUploadRemark });
  };

  let filesGroupByStatus = fileList.reduce((result: any, currentElement: any): any => {
    result[currentElement?.claimStatus] = [...result[currentElement?.claimStatus] || [], currentElement];
    return result;
  }, {});

  if (filesGroupByStatus[NEW_UPLOAD_STATUS]) {
    const temp = filesGroupByStatus[NEW_UPLOAD_STATUS];
    delete filesGroupByStatus[NEW_UPLOAD_STATUS];
    filesGroupByStatus = {
      [NEW_UPLOAD_STATUS]: temp,
      ...filesGroupByStatus,
    };
  }

  return (
    <div>
      <Dragger
          {...draggerActions}
          itemRender={draggerItemRender}
          id="dragger"
          data-testid="dropzone">
          <p className="text-center"><UploadIcon className="fill-primary" /></p>
          <b className="ant-upload-text"> Drag & Drop your file here. </b>
          <p className="ant-upload-hint"> File format needs to be {payer?.allowedFileTypes?.length > 0 ?
            payer?.allowedFileTypes : ALLOWED_FILE_EXTENSIONS.LABEL}</p>
        </Dragger>
        {
        fileList?.length ?
          <Row gutter={GUTTOR_SPACE} className="mb-sm">
            <Col md={6}><strong>Documents</strong></Col>
            <Col md={6}><strong>Uploaded on</strong></Col>
            <Col md={4}><strong>Status</strong></Col>
            <Col md={5}><strong>Document type</strong></Col>
            <Col md={3}><strong>Remove</strong></Col>
          </Row> : null
      }
      {
        Object.keys(filesGroupByStatus).map((statusKey: string): any => (
          <div key={statusKey + Date.now()}>
            <Text type="secondary">{statusKey}</Text>
            {filesGroupByStatus[statusKey].map((file: UploadFile | any, index: number): ReactElement | null =>
              <BuddhiMedUploadListItem file={file} key={file.uid} index={index}
                onRemove={onRemove} fileListLength={filesGroupByStatus[statusKey].length} />)}
          </div>
        ))
      }
    </div>
  );
};

export default FileUploader;
